import { c as _c } from "react/compiler-runtime";
import kebabCase from 'lodash/kebabCase';
import * as React from 'react';
import { useMemo, type JSX } from 'react';
import { uid } from 'uid';
import { generateTestId } from '../../lib/test-helpers';
import { cn } from '../../v2';
interface Props {
  children?: React.ReactNode;
  defaultChecked?: boolean;
  disabled?: boolean;
  isChecked?: boolean;
  label: string;
  name: string;
  onChange?: () => unknown;
  testId?: string;
  value: string | number;
  inputClassName?: string;
  labelClassName?: string;
}
export interface SelectableOption {
  label: string;
  value: string | number;
  testId?: string;
  inputClassName?: string;
  labelClassName?: string;
  disabled?: boolean;
  disabledTooltip?: string;
}
export function RadioButton(t0) {
  const $ = _c(31);
  const {
    children,
    defaultChecked,
    disabled,
    isChecked,
    label,
    name,
    onChange,
    testId: propTestId,
    value,
    inputClassName,
    labelClassName
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = uid();
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  t1 = t2;
  const id = t1;
  let t3;
  if ($[1] !== label || $[2] !== propTestId) {
    t3 = propTestId ?? generateTestId(kebabCase(label), "radio-button");
    $[1] = label;
    $[2] = propTestId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const testId = t3;
  const t4 = !onChange;
  let t5;
  if ($[4] !== inputClassName) {
    t5 = cn("h-5 w-5 shrink-0 appearance-none rounded-full border", "checked:border-blue-500 checked:bg-blue-500", "checked:border-none focus:border-none focus:checked:border-none", "focus:outline-hidden", "checked:shadow-[inset_0_0_0_8px_var(--color-brand-400)]", "focus:shadow-[0_0_8px_0.5px_var(--color-brand-400)]", "focus:checked:shadow-[0_0_8px_0.5px_var(--color-brand-400),inset_0_0_0_8px_var(--color-brand-400)]", "transition-shadow duration-300 ease-in-out", inputClassName);
    $[4] = inputClassName;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== defaultChecked || $[7] !== disabled || $[8] !== isChecked || $[9] !== name || $[10] !== onChange || $[11] !== t4 || $[12] !== t5 || $[13] !== testId || $[14] !== value) {
    t6 = <input checked={isChecked} data-testid={testId} defaultChecked={defaultChecked} disabled={disabled} id={id} name={name} onChange={onChange} readOnly={t4} type="radio" value={value} className={t5} />;
    $[6] = defaultChecked;
    $[7] = disabled;
    $[8] = isChecked;
    $[9] = name;
    $[10] = onChange;
    $[11] = t4;
    $[12] = t5;
    $[13] = testId;
    $[14] = value;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const t7 = disabled && !isChecked;
  let t8;
  if ($[16] !== labelClassName || $[17] !== t7) {
    t8 = cn("text-base", {
      "text-steel-300": t7
    }, labelClassName);
    $[16] = labelClassName;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== label || $[20] !== t8) {
    t9 = <span className={t8}>{label}</span>;
    $[19] = label;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const t10 = isChecked && children ? children : null;
  let t11;
  if ($[22] !== t10 || $[23] !== t9) {
    t11 = <span className="relative box-border inline-block cursor-pointer pl-2 leading-6"><div className="flex flex-col gap-1">{t9}{t10}</div></span>;
    $[22] = t10;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t6) {
    t12 = <div className="flex flex-row items-center">{t6}{t11}</div>;
    $[25] = t11;
    $[26] = t6;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== label || $[29] !== t12) {
    t13 = <label htmlFor={id} aria-label={label} className="h-fit">{t12}</label>;
    $[28] = label;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
}